import { getAPIHost } from '@rsos/utils/metaTags';

export const sendLocation = ({
  latitude,
  longitude,
  phoneNumber,
  source = 'CALL',
}: {
  latitude: number;
  longitude: number;
  phoneNumber: string;
  source?: string;
}) => {
  const url = `${getAPIHost()}/v2/els/location`;
  const now = Date.now();

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: new URLSearchParams({
      v: '2',
      device_number: phoneNumber,
      time: `${now}`,
      location_time: `${now}`,
      location_latitude: `${latitude}`,
      location_longitude: `${longitude}`,
      location_accuracy: '2.5',
      source,
    }),
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
  });
};
